import { render, staticRenderFns } from "./CriteriaSelect.vue?vue&type=template&id=d70c44c4"
import script from "./CriteriaSelect.vue?vue&type=script&lang=js"
export * from "./CriteriaSelect.vue?vue&type=script&lang=js"
import style0 from "./CriteriaSelect.vue?vue&type=style&index=0&id=d70c44c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports